import { get } from 'lodash'
import { runInAction } from 'mobx'
import rootStore from '../..'
import { wrapWithLoading } from '../../../config/general-actions'
import { responseHasError } from '../../users/actions'
import { warnPt } from '../../../config'
import { requireNotificationById } from '../../notifications/action'
import { getNotificationsList } from '../../../api/modules/api-notifications'
const _storeKey = 'uiLstNotifications'

/**
 * @async
 * @function actLoadNotifications
 * @description Asynchronously loads notifications from the server and updates the UI list store.
 * @returns {Promise<void>}
 */
export const actLoadNotifications = wrapWithLoading(
	async () => {
		const params = {
			pg: rootStore[_storeKey].pg,
			rpg: rootStore[_storeKey].rpg,
			entity_table: rootStore[_storeKey].filter?.entity_table || '',
			kind: rootStore[_storeKey].filter?.kind || '',
			progress: rootStore[_storeKey].filter?.progress || '',
			show_all: rootStore[_storeKey].filter?.show_all || false
		}

		const _response = await getNotificationsList(params)
		const { data } = _response

		const hasError = responseHasError(data)
		if (!hasError && data.status === 'success') {
			runInAction(() => {
				_actSync(get(data, ['itms'], []), get(data, ['total'], 0))
			})
		} else {
			throw _response
		}
	},
	{ loadingMessage: 'Loading Notification' }
)

/**
 * @async
 * @function actLoadNotificationsCount
 * @description Asynchronously loads total number of notifications from the server and updates the UI list store.
 * @returns {Promise<void>}
 */
export const actLoadNotificationsCount = wrapWithLoading(
	async () => {
		// TODO: Implement getItemCounts to fetch the number of notification items
		// const _response = await getItemCounts('notifications')
		// const { data } = _response

		// TODO: remove getNotificationsList
		const params = {
			pg: rootStore[_storeKey].pg,
			rpg: rootStore[_storeKey].rpg,
			entity_table: rootStore[_storeKey].filter?.entity_table || '',
			kind: rootStore[_storeKey].filter?.kind || '',
			progress: rootStore[_storeKey].filter?.progress || '',
			show_all: rootStore[_storeKey].filter?.show_all || false
		}
		const _response = await getNotificationsList(params)
		const { data } = _response

		const hasError = responseHasError(data)
		if (!hasError && data.status === 'success') {
			runInAction(() => {
				rootStore[_storeKey].setNr(get(data, ['total'], 0))
			})
		} else {
			throw _response
		}
	},
	{ loadingMessage: 'Loading Notification Count' }
)

/**
 * @function _actSync
 * @description Syncs the server items with the store items.
 * @param {Array} srvItms - Server items.
 * @param {number} nr - Number of items.
 */
const _actSync = (srvItms, nr) => {
	warnPt(srvItms, nr)
	runInAction(() => {
		for (const _srvItm of srvItms) {
			const _storeItm = requireNotificationById(_srvItm.notification_id)
			_storeItm.updateFromServer(_srvItm)
		}
		rootStore[_storeKey].setIds(srvItms.map((it) => it.notification_id))
		rootStore[_storeKey].setNr(nr)
	})
}
